<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 13:55:34
 * @FilePath: \mrc-ess-fronted\src\Layout\components\Container.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-08-09 15:17:22
-->
<template>
  <v-main
    :class="
      !stretchL || !$vuetify.breakpoint.lgAndUp
        ? 'mrc_main_slide_conteiner'
        : 'mrc_main_conteiner'
    "
  >
    <v-container
      fluid
      class="
        scroll_content_y
        pb-0
        d-flex
        flex-column
        main-content
        scroll_content_x_no
        align-center
      "
      :style="{
        height: $vuetify.breakpoint.height - 56 + 'px',
        position: 'relative',
        paddingRight:
          $route.path === '/dashboard' &&
          $vuetify.breakpoint.name != 'xs' &&
          stretchR &&
          $vuetify.breakpoint.lgAndUp
            ? '352px'
            : '12px',
      }"
    >
      <!-- <Announcement
        @hasAnnouncement="(announcement) => (announcements = announcement)"
      /> -->
      <v-container
        v-if="!hidden"
        fluid
        :class="LRPadding + ' pb-0'"
        class="scroll_content_y no_scroll d-flex flex-column justify-start"
        :style="{
          minHeight: $vuetify.breakpoint.height - 56 - 52 + 'px',
          maxWidth: fillWidth ? '100%' : isSpecial ? '2000px' : '1600px',
        }"
      >
        <!-- god模式不判断权限 -->
        <template v-if="Number(SYSTEM_STATUS) == 3 && !isGod">
          <!-- 没有权限 -->
          <PermissionPage />
        </template>
        <template v-if="Number(SYSTEM_STATUS) == 2">
          <!-- 系统错误 -->
          <SystemErrorPage />
        </template>
        <template v-if="Number(SYSTEM_STATUS) == 1">
          <!-- 网络错误 -->
          <NetErrorPage />
        </template>
        <template v-if="Number(SYSTEM_STATUS) == 0 || isGod">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
          </keep-alive>
          <!-- <transition
            name="scroll-x-transition"
            mode="out-in"
            appear
            
          > -->
          <router-view v-if="!$route.meta.keepAlive" />
        </template>
      </v-container>
      <v-sheet
        class="close_triger d-flex align-center rounded-l-lg"
        width="20"
        height="40"
        :style="{
          right: stretchR && $vuetify.breakpoint.lgAndUp ? '334px' : '-0px',
          top: Number(scrollTopofMain) + 60 + 'px',

          zIndex: 999,
        }"
        @click="$emit('slideRightChange', !stretchR)"
        v-if="$route.path === '/dashboard' && $vuetify.breakpoint.lgAndUp"
      >
        <span class="material-icons-round ma-auto">{{
          !stretchR ? "arrow_left" : "arrow_right"
        }}</span>
      </v-sheet>
      <v-spacer />
      <Footer
        :center="$route.path == '/dashboard'"
        :maxWidth="fillWidth ? '100%' : isSpecial ? '2000px' : '1600px'"
      />
    </v-container>
  </v-main>
</template>
<script>
import { mapGetters } from "vuex";
import Footer from "@/Layout/components/Footer";
import NetErrorPage from "@/Layout/NetErrorPage";
import SystemErrorPage from "@/Layout/SystemErrorPage";
import PermissionPage from "@/Layout/PermissionPage";

export default {
  name: "Container",
  components: {
    Footer,
    NetErrorPage,
    SystemErrorPage,
    PermissionPage,
  },

  computed: {
    ...mapGetters(["defaultLang", "SYSTEM_STATUS", "isDemo", "FunctionUuid"]),
    hiddenBread() {
      switch (this.$route.path) {
        case "/dashboard":
          return true;
          break;
        case "/404":
          return true;
          break;
        case "/net_error":
          return true;
          break;
        case "/system_error":
          return true;
          break;
        default:
          return false;
          break;
      }
    },
    key() {
      return this.$route.fullPath;
    },
    LRPadding() {
      switch (this.$vuetify.breakpoint.name) {
        case "lg":
          return "pa-4";
          break;
        case "xl":
          return "pa-4";
          break;
        case "md":
          return "pa-4";
          break;
        case "sm":
          return "pa-0";
          break;
        case "xs":
          return "pa-0";
          break;
        default:
          return "pa-4";
          break;
      }
    },
    fillWidth() {
      if (
        this.$route.path.indexOf("duty-schedule") != -1 ||
        this.$route.path.indexOf("duty-roster") != -1
      )
        return true;
      // if (this.$route.path.indexOf("/roster-form-record/edit/") != -1)
      //   return true;
    },
    isGod() {
      return this.isDemo === "true" || this.isDemo == true;
    },
    isSpecial() {
      let curPath = this.$route.path;
      return this.specialRouter.some((item) => {
        return curPath.indexOf(item) != -1;
      });
    },
  },
  props: {
    hidden: { default: false, type: Boolean },
    stretch: { default: false, type: Boolean },
    stretchL: { default: false, type: Boolean },
    stretchR: { default: false, type: Boolean },
  },
  data() {
    return {
      curkey: 0,
      announcements: [],
      scrollTopofMain: 0,
      specialRouter: [
        //根据路由特殊展示宽度
        "attendance-internal",
        "attendance-record",
        "my-attendance",
        "subordinate-attendance",
      ],
    };
  },
  watch: {
    FunctionUuid: {
      handler(val) {
        if (val) {
          // this.getBtnPermissionList();
        }
      },
      deep: true,
      immediate: true,
    },
    defaultLang() {
      // this.curkey = Math.random() * 10000000;
    },
  },
  created() {
    // 重置页面状态
    // this.$store.dispatch("updateSystemStatus", 0);
  },
  mounted() {
    const that = this;
    $(".main-content").on("scroll", function (e) {
      that.scrollTopofMain = $(".main-content").scrollTop();
    });
  },
  methods: {
    onPopChange: function (show) {
      this.$emit("onPopChange", show);
    },
  },
};
</script>
<style scoped>
.mrc_main_conteiner {
  padding: 56px 0px 0px 240px !important;
}
.mrc_main_slide_conteiner {
  padding: 56px 0px 0px 0px !important;
}
.close_triger {
  position: absolute;
  top: 120px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-right: none;
}
.close_triger:hover {
  transform: scale(1.05);
}
.close_triger > span:hover {
  transform: scale(1.2);
  animation-duration: 1s;
}
</style>
